module.exports = __webpack_public_path__ + "img/stock5.d5354a10.png";